<script setup lang="ts">
defineProps({
	width: {
		type: String,
		default: '20',
	},
	height: {
		type: String,
		default: '20',
	},
	isColorful: {
		type: Boolean,
		default: false,
	},
});
</script>
<template>
	<template v-if="isColorful">
		<svg
			:width="width"
			:height="height"
			:viewBox="`0 0 ${width} ${height}`"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V10.75C1.25 13.5503 1.25 14.9504 1.79497 16.02C2.27433 16.9608 3.03924 17.7257 3.98005 18.205C5.04961 18.75 6.44974 18.75 9.25 18.75H10.75C13.5503 18.75 14.9504 18.75 16.02 18.205C16.9608 17.7257 17.7257 16.9608 18.205 16.02C18.75 14.9504 18.75 13.5503 18.75 10.75V9.25C18.75 6.44974 18.75 5.04961 18.205 3.98005C17.7257 3.03924 16.9608 2.27433 16.02 1.79497C14.9504 1.25 13.5503 1.25 10.75 1.25H9.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005Z"
				fill="#6972DD"
			/>
			<path
				d="M1.41576 5.17489C1.25 6.11694 1.25 7.36692 1.25 9.25016V10.7502C1.25 13.5504 1.25 14.9505 1.79497 16.0201C2.27433 16.9609 3.03924 17.7258 3.98005 18.2052C5.04961 18.7502 6.44974 18.7502 9.25 18.7502H10.75C13.5503 18.7502 14.9504 18.7502 16.02 18.2052C16.9608 17.7258 17.7257 16.9609 18.205 16.0201C18.75 14.9505 18.75 13.5504 18.75 10.7502V9.25016C18.75 6.44989 18.75 5.04976 18.205 3.9802C17.7423 3.07213 17.0136 2.32793 16.1175 1.84619L1.41576 5.17489Z"
				fill="#6972DD"
			/>
			<path
				d="M18.5694 14.9087C18.4891 15.331 18.3731 15.6911 18.2055 16.0199C17.7262 16.9607 16.9613 17.7256 16.0205 18.2049C14.9829 18.7336 13.6343 18.7494 10.9982 18.7499H10.0371V16.7729L18.5694 14.9087Z"
				fill="#6972DD"
			/>
			<path
				d="M10.7508 1.25H9.25084C8.70605 1.25 8.21426 1.25 7.76758 1.25401V3.73157L16.1167 1.84516C16.085 1.8281 16.053 1.81136 16.0208 1.79497C15.427 1.49243 14.7314 1.35784 13.7508 1.29797C12.9651 1.25 11.9965 1.25 10.7508 1.25Z"
				fill="#6972DD"
			/>
			<path
				d="M18.7501 10.8585C18.75 12.737 18.7467 13.9752 18.5691 14.9089L15.6016 15.5573V11.135L18.7501 10.4028V10.8585Z"
				fill="#6972DD"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M9.33862 8.36143C9.33862 7.95976 9.66702 7.80527 10.2109 7.80527C10.9909 7.80527 11.9761 8.04215 12.7561 8.46442V6.04408C11.9043 5.7042 11.0627 5.57031 10.2109 5.57031C8.12764 5.57031 6.74219 6.66204 6.74219 8.48502C6.74219 11.3276 10.642 10.8745 10.642 12.1001C10.642 12.5739 10.2315 12.7283 9.65676 12.7283C8.80497 12.7283 7.71713 12.3782 6.85508 11.9044V14.3556C7.8095 14.7676 8.77418 14.9427 9.65676 14.9427C11.7914 14.9427 13.2589 13.8819 13.2589 12.0383C13.2487 8.96909 9.33862 9.51495 9.33862 8.36143Z"
				fill="white"
			/>
		</svg>
	</template>
	<template v-else>
		<svg
			:width="width"
			:height="height"
			:viewBox="`0 0 ${width} ${height}`"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V10.75C1.25 13.5503 1.25 14.9504 1.79497 16.02C2.27433 16.9608 3.03924 17.7257 3.98005 18.205C5.04961 18.75 6.44974 18.75 9.25 18.75H10.75C13.5503 18.75 14.9504 18.75 16.02 18.205C16.9608 17.7257 17.7257 16.9608 18.205 16.02C18.75 14.9504 18.75 13.5503 18.75 10.75V9.25C18.75 6.44974 18.75 5.04961 18.205 3.98005C17.7257 3.03924 16.9608 2.27433 16.02 1.79497C14.9504 1.25 13.5503 1.25 10.75 1.25H9.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005Z"
				fill="white"
			/>
			<path
				d="M1.41576 5.17489C1.25 6.11694 1.25 7.36692 1.25 9.25016V10.7502C1.25 13.5504 1.25 14.9505 1.79497 16.0201C2.27433 16.9609 3.03924 17.7258 3.98005 18.2052C5.04961 18.7502 6.44974 18.7502 9.25 18.7502H10.75C13.5503 18.7502 14.9504 18.7502 16.02 18.2052C16.9608 17.7258 17.7257 16.9609 18.205 16.0201C18.75 14.9505 18.75 13.5504 18.75 10.7502V9.25016C18.75 6.44989 18.75 5.04976 18.205 3.9802C17.7423 3.07213 17.0136 2.32793 16.1175 1.84619L1.41576 5.17489Z"
				fill="white"
			/>
			<path
				d="M18.5694 14.9087C18.4891 15.331 18.3731 15.6911 18.2055 16.0199C17.7262 16.9607 16.9613 17.7256 16.0205 18.2049C14.9829 18.7336 13.6343 18.7494 10.9982 18.7499H10.0371V16.7729L18.5694 14.9087Z"
				fill="white"
			/>
			<path
				d="M10.7499 1.25H9.24986C8.70507 1.25 8.21328 1.25 7.7666 1.25401V3.73157L16.1157 1.84516C16.084 1.8281 16.052 1.81136 16.0198 1.79497C15.426 1.49243 14.7304 1.35784 13.7499 1.29797C12.9642 1.25 11.9955 1.25 10.7499 1.25Z"
				fill="white"
			/>
			<path
				d="M18.7501 10.8585C18.75 12.737 18.7467 13.9752 18.5691 14.9089L15.6016 15.5573V11.135L18.7501 10.4028V10.8585Z"
				fill="white"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M9.33764 8.36143C9.33764 7.95976 9.66605 7.80527 10.21 7.80527C10.9899 7.80527 11.9751 8.04215 12.7551 8.46442V6.04408C11.9033 5.7042 11.0618 5.57031 10.21 5.57031C8.12666 5.57031 6.74121 6.66204 6.74121 8.48502C6.74121 11.3276 10.641 10.8745 10.641 12.1001C10.641 12.5739 10.2305 12.7283 9.65578 12.7283C8.80399 12.7283 7.71616 12.3782 6.8541 11.9044V14.3556C7.80852 14.7676 8.7732 14.9427 9.65578 14.9427C11.7904 14.9427 13.2579 13.8819 13.2579 12.0383C13.2477 8.96909 9.33764 9.51495 9.33764 8.36143Z"
				fill="#6972DD"
			/>
		</svg>
	</template>
</template>
